<template>
  <header class="simulation-page-header">
    <div class="header-row first-row">
      <span>{{ title }}</span>
      <span
        v-if="subtitle"
      > - {{ subtitle }}
      </span>
      <span
        class="header-right"
      >
        <span
          v-if="timeLeftInSeconds !== null"
          class="flex-row align-center"
        >
          <icon
            name="clock"
            variant="white"
          ></icon>
          Time Remaining: {{ timeRemaining }}
        </span>
        <span
          v-if="questionNumber"
          class="flex-row align-center"
        >
          <icon
            name="question-count"
            variant="white"
          ></icon>
          Question {{ questionNumber }} of {{ totalQuestions }}
        </span>
      </span>
    </div>
    <div class="header-row second-row">
      <span
        v-if="includeCalculator"
        class="flex-row align-center cursor-pointer"
        @click="$emit('calculator-clicked')"
      >
        <icon
          name="calculator"
          variant="white"
          class="calculator-icon"
        ></icon>
        <span>Calculator</span>
      </span>
    </div>
  </header>
</template>

<script>
import { formatTime } from '@/utils/stringFormats.js';
import Icon from '@components/singletons/icon.vue';

export default {
  components: { Icon },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    timeLeftInSeconds: {
      type: Number,
      default: null,
    },
    questionNumber: {
      type: Number,
      default: null,
    },
    totalQuestions: {
      type: Number,
      default: null,
    },
    includeCalculator: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    timeRemaining() {
      return formatTime(this.timeLeftInSeconds);
    },
  },
};
</script>

<style lang="scss" scoped>
.simulation-page-header {
  font-size: 1.625rem;

  .header-row {
    border-bottom: 2px solid white;
    color: white;
    font-size: 1.625rem;
    padding: 0.375rem;
    min-height: 2rem;
  }

  .first-row {
    line-height: 2.75rem;
    background-color: #006AAC;
  }

  .second-row {
    background-color: #7EACE3;
    height: 2rem;
    font-size: 1.35rem;
    line-height: 2rem;
  }

  .header-right {
    float: right;
    font-size: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }

  .align-center {
    align-items: center;
  }

  .calculator-icon {
    height: 1.5rem;
  }

  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
